import FinalizeJobsNoLongerReadyChoiceEnum from '../Enums/FinalizeJobsNoLongerReadyChoiceEnum';

export default class FinalizeTpClientInvoiceBulkItem {
  constructor() {
    this.IdListString = '';
    this.AllItemsInTheSearchSetAreSelected = false;
    this.NumberOfItemsSelected = 0;
    // What to do with the shops that no longer pass the Ready for Invoicing rules: the Bulk Finalization window's
    // choice or the Finalize Selected window's, which start on Remove.
    this.JobsNoLongerReadyChoice = FinalizeJobsNoLongerReadyChoiceEnum.Remove;
    this.Comment = '';
  }
}
